<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 579.02 142.86"
  >
    <defs>
      <linearGradient
        id="degrade_2"
        x1="50.82"
        y1="103.67"
        x2="75.7"
        y2="103.67"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#3c3839" />
        <stop offset="1" stop-color="#3c3737" />
      </linearGradient>
      <linearGradient
        id="degrade_2-2"
        x1="82.61"
        y1="63.92"
        x2="134.46"
        y2="63.92"
        xlink:href="#degrade_2"
      />
      <linearGradient
        id="degrade_2-3"
        x1="26.59"
        y1="39.7"
        x2="67.84"
        y2="39.7"
        xlink:href="#degrade_2"
      />
      <linearGradient
        id="degrade_2-4"
        x1="84.38"
        y1="129.7"
        x2="115.05"
        y2="129.7"
        xlink:href="#degrade_2"
      />
      <linearGradient
        id="degrade_2-5"
        x1="121.8"
        y1="103.89"
        x2="139.53"
        y2="103.89"
        xlink:href="#degrade_2"
      />
      <linearGradient
        id="degrade_2-6"
        x1="18.24"
        y1="116.54"
        x2="50.43"
        y2="116.54"
        xlink:href="#degrade_2"
      />
      <linearGradient
        id="degrade_2-7"
        x1="5.16"
        y1="38.49"
        x2="25.5"
        y2="38.49"
        xlink:href="#degrade_2"
      />
      <linearGradient
        id="degrade_2-8"
        x1="38.5"
        y1="10.92"
        x2="79.66"
        y2="10.92"
        xlink:href="#degrade_2"
      />
      <linearGradient
        id="degrade_2-9"
        x1="327.28"
        y1="37.76"
        x2="362.08"
        y2="37.76"
        xlink:href="#degrade_2"
      />
      <linearGradient
        id="degrade_2-10"
        x1="359.79"
        y1="43.69"
        x2="397.71"
        y2="43.69"
        xlink:href="#degrade_2"
      />
      <linearGradient
        id="degrade_2-11"
        x1="402.94"
        y1="44.05"
        x2="427.93"
        y2="44.05"
        xlink:href="#degrade_2"
      />
      <linearGradient
        id="degrade_2-12"
        x1="432.33"
        y1="43.72"
        x2="479.54"
        y2="43.72"
        xlink:href="#degrade_2"
      />
      <linearGradient
        id="degrade_2-13"
        x1="485.95"
        y1="44.4"
        x2="519.13"
        y2="44.4"
        xlink:href="#degrade_2"
      />
      <linearGradient
        id="degrade_2-14"
        x1="526.33"
        y1="36.67"
        x2="535.87"
        y2="36.67"
        xlink:href="#degrade_2"
      />
      <linearGradient
        id="degrade_2-15"
        x1="541.1"
        y1="43.69"
        x2="579.02"
        y2="43.69"
        xlink:href="#degrade_2"
      />
      <linearGradient
        id="degrade_2-16"
        x1="181.29"
        y1="108.42"
        x2="230.96"
        y2="108.42"
        xlink:href="#degrade_2"
      />
      <linearGradient
        id="degrade_2-17"
        x1="237.92"
        y1="115.4"
        x2="271.09"
        y2="115.4"
        xlink:href="#degrade_2"
      />
      <linearGradient
        id="degrade_2-18"
        x1="278.3"
        y1="107.67"
        x2="287.83"
        y2="107.67"
        xlink:href="#degrade_2"
      />
      <linearGradient
        id="degrade_2-19"
        x1="292.44"
        y1="107.67"
        x2="320.83"
        y2="107.67"
        xlink:href="#degrade_2"
      />
      <linearGradient
        id="degrade_2-20"
        x1="324.58"
        y1="106.86"
        x2="337.3"
        y2="106.86"
        xlink:href="#degrade_2"
      />
    </defs>
    <path
      style="fill: url(#degrade_2)"
      d="m59.55 122.15 16.15-41.9-12.11 2.57-12.77 35.65.85 8.62 7.88-4.94z"
    />
    <path
      style="fill: url(#degrade_2-2)"
      d="m94.2 69.24 40.26-8.25-.22-2.39-40.19 2.85-11.44.21 11.59 7.58z"
    />
    <path
      style="fill: url(#degrade_2-3)"
      d="M63.86 48.51 40.25 22.35l-13.66 1.47 5.56 6.55 24.48 25.7 11.21.99-3.98-8.55z"
    />
    <path
      style="fill: url(#degrade_2-4)"
      d="m87.14 131.06 25.88-6.32 2.03 5.61-27.22 4.3-3.45-1.03 2.76-2.56z"
    />
    <path
      style="fill: url(#degrade_2-5)"
      d="m124.62 112.87 11.21-21.97 3.7.45-.68 1.29-9.46 23.22-7.59 1.03 2.82-4.02z"
    />
    <path
      style="fill: url(#degrade_2-6)"
      d="M41.63 122.67 21.42 104.5l-3.18 2.26 1.7 2.18 18.88 19.65h11.61l-8.8-5.92z"
    />
    <path
      style="fill: url(#degrade_2-7)"
      d="m5.16 56.89 11.78-30.55 8.56-11.02-3.1 14.94L8.99 58.6l-3.83 3.06v-4.77z"
    />
    <path
      style="fill: url(#degrade_2-8)"
      d="M76.49 4.33 38.5 9.44v8.07l2.53-1.64 36.23-8.02 2.4-1.82-3.17-1.7z"
    />
    <circle style="fill: #fe4e15" cx="74.34" cy="65.74" r="20.17" />
    <circle style="fill: #fe4e15" cx="27.42" cy="17.51" r="13.71" />
    <circle style="fill: #fe4e15" cx="5.16" cy="62.04" r="5.16" />
    <circle style="fill: #fe4e15" cx="121.8" cy="122.69" r="10.22" />
    <circle style="fill: #fe4e15" cx="138.3" cy="88.2" r="4.44" />
    <circle style="fill: #fe4e15" cx="83.52" cy="133.62" r="4.44" />
    <circle style="fill: #fe4e15" cx="18.24" cy="104.5" r="4.44" />
    <circle style="fill: #fe4e15" cx="81.65" cy="5.16" r="5.16" />
    <circle style="fill: #fe4e15" cx="142.54" cy="59.09" r="8.3" />
    <circle style="fill: #fe4e15" cx="50.82" cy="130.67" r="12.19" />
    <path
      style="fill: #fe4e15"
      d="M230 38a24.87 24.87 0 0 1-.92 6.81 26 26 0 0 1-2.58 6.13 25.41 25.41 0 0 1-4 5.22 26 26 0 0 1-5.2 4 25.7 25.7 0 0 1-6.13 2.6 25.4 25.4 0 0 1-6.83.91 25.15 25.15 0 0 1-6.81-.91 25.67 25.67 0 0 1-11.35-6.64 25.82 25.82 0 0 1-6.64-11.35A25.58 25.58 0 0 1 182.1 25a26.3 26.3 0 0 1 4-5.2 25.62 25.62 0 0 1 5.21-4 26.07 26.07 0 0 1 6.14-2.58 25.16 25.16 0 0 1 6.81-.92 25.58 25.58 0 0 1 18.16 7.52 25.49 25.49 0 0 1 6.6 11.34A25 25 0 0 1 230 38Zm-9.88 0a15.41 15.41 0 0 0-1.24-6.16 15.76 15.76 0 0 0-8.41-8.4 15.8 15.8 0 0 0-12.32 0 16.3 16.3 0 0 0-5 3.38 15.77 15.77 0 0 0-3.39 5 15.42 15.42 0 0 0-1.3 6.18 15.11 15.11 0 0 0 1.25 6.11 16 16 0 0 0 8.42 8.41 15.8 15.8 0 0 0 12.32 0 15.84 15.84 0 0 0 5-3.4 16.21 16.21 0 0 0 3.38-5A15.1 15.1 0 0 0 220.1 38ZM245 76.75h-9.54V25.49h2.29l3.81 4.51a24.75 24.75 0 0 1 2.81-2.29 21.48 21.48 0 0 1 3.17-1.85 18.76 18.76 0 0 1 3.46-1.27 14.44 14.44 0 0 1 3.57-.45 19.3 19.3 0 0 1 7.37 1.4 18.24 18.24 0 0 1 6 4A18.47 18.47 0 0 1 272 35.7a20.76 20.76 0 0 1 1.49 8A21.51 21.51 0 0 1 272 52a18.27 18.27 0 0 1-4.07 6.21 17.9 17.9 0 0 1-6 3.9 20.06 20.06 0 0 1-7.37 1.35 11.64 11.64 0 0 1-2.48-.28 15.35 15.35 0 0 1-2.42-.75c-.8-.31-1.58-.66-2.36-1.05s-1.52-.8-2.23-1.22Zm19-33a11.31 11.31 0 0 0-.75-4.23 9.39 9.39 0 0 0-2-3.17 8.65 8.65 0 0 0-3-2 9.68 9.68 0 0 0-3.68-.7 9.49 9.49 0 0 0-3.65.7 8.61 8.61 0 0 0-3 2 9.39 9.39 0 0 0-2 3.17 11.31 11.31 0 0 0-.74 4.23 11 11 0 0 0 .74 4.12 9.48 9.48 0 0 0 2 3.19 9.05 9.05 0 0 0 3 2 9.33 9.33 0 0 0 3.65.73 9.51 9.51 0 0 0 3.68-.73 9.09 9.09 0 0 0 3-2 9.48 9.48 0 0 0 2-3.19 11 11 0 0 0 .75-4.15ZM297.05 62.61a16 16 0 0 1-6.44-1.3 16.74 16.74 0 0 1-8.86-8.86 16 16 0 0 1-1.3-6.44V35h-4.61v-9.44h4.61V10.72h9.43v14.84h14.35V35h-14.35v11a7.05 7.05 0 0 0 .55 2.79 7.21 7.21 0 0 0 1.57 2.28 7.39 7.39 0 0 0 2.28 1.54 7 7 0 0 0 2.81.57h7.18v9.43ZM320.69 15.4a6.11 6.11 0 0 1-.5 2.46 6.36 6.36 0 0 1-1.37 2 6.79 6.79 0 0 1-2 1.35 6.38 6.38 0 0 1-5 0 6.28 6.28 0 0 1-3.37-3.35 6.25 6.25 0 0 1 0-4.9 6.46 6.46 0 0 1 1.35-2 6.28 6.28 0 0 1 2-1.35 6.26 6.26 0 0 1 5 0 6.44 6.44 0 0 1 2 1.35 6.25 6.25 0 0 1 1.87 4.45Zm-1.63 47.21h-9.53V25.49h9.53Z"
    />
    <path
      d="M337.22 62.61h-9.94v-49.7h34.8v9.94h-24.86v9.95h14.91v10h-14.91Z"
      style="fill: url(#degrade_2-9)"
    />
    <path
      d="M397.71 43.72a20.11 20.11 0 0 1-1.49 7.75 19.44 19.44 0 0 1-4.06 6.2 19 19 0 0 1-6 4.13 18.93 18.93 0 0 1-14.77 0 19 19 0 0 1-10.1-10.33 20.11 20.11 0 0 1-1.49-7.75 20.34 20.34 0 0 1 1.49-7.83 19.17 19.17 0 0 1 4.07-6.23 18.91 18.91 0 0 1 6-4.1 18.29 18.29 0 0 1 7.37-1.49 19.38 19.38 0 0 1 7.4 1.4 18 18 0 0 1 6 4 19 19 0 0 1 4.06 6.2 21.08 21.08 0 0 1 1.52 8.05Zm-9.53 0a10.91 10.91 0 0 0-.75-4.14 9.78 9.78 0 0 0-2-3.19 8.76 8.76 0 0 0-3-2 9.76 9.76 0 0 0-7.31 0 8.68 8.68 0 0 0-3 2 9.69 9.69 0 0 0-2 3.19 11.1 11.1 0 0 0-.73 4.14 10.68 10.68 0 0 0 .73 4 10 10 0 0 0 2 3.18 9.22 9.22 0 0 0 3 2.14 8.75 8.75 0 0 0 3.66.78 9.33 9.33 0 0 0 3.65-.73 9.05 9.05 0 0 0 3-2 9.48 9.48 0 0 0 2-3.19 11 11 0 0 0 .75-4.18Z"
      style="fill: url(#degrade_2-10)"
    />
    <path
      d="M412.4 62.61h-9.46V25.49h2.29l3.12 4.4a16.41 16.41 0 0 1 5.2-3.21 16.58 16.58 0 0 1 6-1.12h8.35V35h-8.35a7.13 7.13 0 0 0-7.18 7.17Z"
      style="fill: url(#degrade_2-11)"
    />
    <path
      d="M479.54 62.61h-9.43V39a4.69 4.69 0 0 0-1.38-3.36 4.66 4.66 0 0 0-1.53-1 4.54 4.54 0 0 0-1.83-.37 4.61 4.61 0 0 0-3.31 1.39 4.87 4.87 0 0 0-1 1.52 4.75 4.75 0 0 0-.36 1.84v23.59h-9.47V39a4.69 4.69 0 0 0-1.38-3.36 4.66 4.66 0 0 0-1.53-1 4.54 4.54 0 0 0-1.83-.37 4.61 4.61 0 0 0-3.31 1.39 4.87 4.87 0 0 0-1 1.52 4.75 4.75 0 0 0-.38 1.82v23.61h-9.47V25.49h2.29l2.57 2.84a15 15 0 0 1 4.35-2.58 13.73 13.73 0 0 1 10 .05 10.24 10.24 0 0 1 4.35 3.36 9.94 9.94 0 0 1 2-2 11.45 11.45 0 0 1 2.34-1.35 11.32 11.32 0 0 1 2.55-.75 15.3 15.3 0 0 1 2.6-.22 13.82 13.82 0 0 1 5.52 1.11 14.08 14.08 0 0 1 7.54 7.55 14 14 0 0 1 1.1 5.5Z"
      style="fill: url(#degrade_2-12)"
    />
    <path
      d="M513.72 58.28a26.62 26.62 0 0 1-2.45 2 18.06 18.06 0 0 1-2.72 1.59 16.06 16.06 0 0 1-2.93 1.07 11.68 11.68 0 0 1-3.06.4 17.09 17.09 0 0 1-6.45-1.21 15.67 15.67 0 0 1-8.86-8.89A19.14 19.14 0 0 1 486 46V25.49h9.43V46a9.17 9.17 0 0 0 .57 3.34 7.47 7.47 0 0 0 1.55 2.48 6.42 6.42 0 0 0 2.27 1.53 7.52 7.52 0 0 0 2.79.52 5.86 5.86 0 0 0 2.75-.68 7.6 7.6 0 0 0 2.27-1.79 8.33 8.33 0 0 0 1.53-2.51 7.77 7.77 0 0 0 .55-2.89V25.49h9.47v37.12h-2.29Z"
      style="fill: url(#degrade_2-13)"
    />
    <path
      d="M535.87 62.61h-9.54V10.72h9.54Z"
      style="fill: url(#degrade_2-14)"
    />
    <path
      d="M579 62.61h-2.29l-3.67-5.1a31.76 31.76 0 0 1-2.86 2.28 21.73 21.73 0 0 1-3.18 1.83 19.41 19.41 0 0 1-3.42 1.23 14.16 14.16 0 0 1-3.55.45 20.67 20.67 0 0 1-7.34-1.3 17.67 17.67 0 0 1-6-3.83 18 18 0 0 1-4.1-6.17 21.71 21.71 0 0 1-1.49-8.28 20.73 20.73 0 0 1 1.49-7.95 19 19 0 0 1 4.07-6.23 18.35 18.35 0 0 1 6-4 19 19 0 0 1 7.37-1.44 14.44 14.44 0 0 1 3.57.45 17.85 17.85 0 0 1 3.43 1.25 20.61 20.61 0 0 1 3.17 1.87 25.51 25.51 0 0 1 2.86 2.33l3.67-4.4H579Zm-9.53-18.89a9.78 9.78 0 0 0-.75-3.76 10.53 10.53 0 0 0-2-3.22 10.05 10.05 0 0 0-3-2.26 8.26 8.26 0 0 0-3.66-.85 10.15 10.15 0 0 0-3.66.66 8.49 8.49 0 0 0-3 1.94 9.21 9.21 0 0 0-2 3.17 13.15 13.15 0 0 0 0 8.64 9.21 9.21 0 0 0 2 3.17 8.49 8.49 0 0 0 3 1.94 10.15 10.15 0 0 0 3.66.66 8.26 8.26 0 0 0 3.66-.85 10.05 10.05 0 0 0 3-2.26 10.53 10.53 0 0 0 2-3.22 9.78 9.78 0 0 0 .77-3.76Z"
      style="fill: url(#degrade_2-15)"
    />
    <path
      d="M231 133.61h-10V98.12a4.68 4.68 0 0 0-.4-1.94 5.07 5.07 0 0 0-1.07-1.58 5 5 0 0 0-8.48 3.52v35.49h-9.94V98.12a4.91 4.91 0 0 0-1.44-3.52 5 5 0 0 0-8.48 3.52v35.49h-9.94V98.12a14.48 14.48 0 0 1 1.16-5.8 14.66 14.66 0 0 1 3.19-4.75 14.88 14.88 0 0 1 4.74-3.19 14.56 14.56 0 0 1 5.81-1.16 14.91 14.91 0 0 1 5.34 1 14.61 14.61 0 0 1 4.61 2.86 14.85 14.85 0 0 1 15.72-2.68 15 15 0 0 1 4.75 3.19 14.79 14.79 0 0 1 3.18 4.75 14.49 14.49 0 0 1 1.17 5.8Z"
      style="fill: url(#degrade_2-16)"
    />
    <path
      d="M265.69 129.28a26.29 26.29 0 0 1-2.45 2 18.06 18.06 0 0 1-2.72 1.59 17.18 17.18 0 0 1-2.93 1.08 12.12 12.12 0 0 1-3.06.4 17.1 17.1 0 0 1-6.45-1.22 15.85 15.85 0 0 1-5.29-3.44 16.13 16.13 0 0 1-3.57-5.45 19.07 19.07 0 0 1-1.3-7.19V96.49h9.43V117a9.27 9.27 0 0 0 .57 3.35 7.41 7.41 0 0 0 1.54 2.47 6.6 6.6 0 0 0 2.27 1.53 7.42 7.42 0 0 0 2.8.52 5.89 5.89 0 0 0 2.75-.68 7.69 7.69 0 0 0 2.27-1.78 8.59 8.59 0 0 0 1.53-2.51 7.82 7.82 0 0 0 .55-2.9V96.49h9.46v37.12h-2.28Z"
      style="fill: url(#degrade_2-17)"
    />
    <path
      d="M287.83 133.61h-9.53V81.73h9.53Z"
      style="fill: url(#degrade_2-18)"
    />
    <path
      d="M313.66 133.61a16.06 16.06 0 0 1-6.45-1.3 16.69 16.69 0 0 1-5.29-3.57 16.86 16.86 0 0 1-3.57-5.28 16.23 16.23 0 0 1-1.3-6.45V106h-4.61v-9.44h4.61V81.73h9.43v14.83h14.35V106h-14.35v11a7 7 0 0 0 .56 2.79 7.07 7.07 0 0 0 1.52 2.27 7.27 7.27 0 0 0 2.29 1.54 6.83 6.83 0 0 0 2.81.58h7.17v9.42Z"
      style="fill: url(#degrade_2-19)"
    />
    <path
      d="M337.3 86.41a6 6 0 0 1-.51 2.46 6.26 6.26 0 0 1-1.37 2 6.39 6.39 0 0 1-2 1.35 6.4 6.4 0 0 1-5 0 6.33 6.33 0 0 1-3.36-3.34 6.28 6.28 0 0 1 0-4.91 6.35 6.35 0 0 1 1.35-2 6.7 6.7 0 0 1 2-1.35 6.4 6.4 0 0 1 5 0 6.75 6.75 0 0 1 2 1.35 6.24 6.24 0 0 1 1.37 2 6 6 0 0 1 .52 2.44Zm-1.63 47.2h-9.54V96.49h9.54Z"
      style="fill: url(#degrade_2-20)"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
